// Fichier de configuration centralisé : toutes les données de l'entreprise sont lues ici.
export const site = {
  name: "MINES DE PARIS",
  shortName: "Mines de Paris",
  baseline: "Négoce et commerce de gros de produits non alimentaires",
  tagline:
    "Partenaire interentreprises pour l'approvisionnement, le sourcing et le négoce de produits non alimentaires, en France et à l'international.",
  url: "https://minesdeparis.world",
  domain: "minesdeparis.world",
  legalForm: "Société par Actions Simplifiée Unipersonnelle (SASU)",
  legalFormShort: "SASU",
  capital: "1 000,00 €",
  address: {
    street: "36 Parc des Contrillières",
    postalCode: "93500",
    city: "PANTIN",
    cityDisplay: "Pantin",
    country: "France",
    full: "36 Parc des Contrillières, 93500 PANTIN, France",
    geo: { lat: 48.8966, lng: 2.4043 },
  },
  rcs: "995 401 502 R.C.S. Bobigny",
  rcsNumber: "995 401 502",
  rcsCity: "Bobigny",
  siren: "995 401 502",
  euid: "FR9301.995401502",
  vat: "FR57995401502",
  registrationDate: "22 décembre 2025",
  registrationDateISO: "2025-12-22",
  activityStart: "1er janvier 2026",
  duration: "jusqu'au 22 décembre 2124",
  fiscalYearEnd: "31 décembre",
  president: {
    civility: "Monsieur",
    firstName: "Abdesslam",
    lastName: "DRIAS",
    fullName: "Abdesslam DRIAS",
    title: "Président",
    birth: "né le 17/03/1967 à Alger (Algérie), de nationalité algérienne",
    address: "36 Parc des Contrillières, 93500 Pantin",
  },
  activities: {
    main: "Commerce de gros de produits non alimentaires ; services interentreprises de négoce",
    secondary:
      "Toutes opérations industrielles, commerciales, financières, civiles, mobilières ou immobilières pouvant se rattacher directement ou indirectement à l'objet social ou à tous objets similaires ou connexes",
  },
  phone: "+33 7 46 52 86 72",
  phoneHref: "tel:+33746528672",
  email: "contact@minesdeparis.world",
  emailHref: "mailto:contact@minesdeparis.world",
  hours: "Lundi au vendredi, 9h00 – 18h00 (heure de Paris), hors jours fériés",
  quoteDelay: "48 h ouvrées",
  responseDelay: "1 jour ouvré",
  host: {
    name: "Namecheap, Inc.",
    address: "4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis",
    url: "https://www.namecheap.com",
    support: "support en ligne (chat et tickets) accessible 24h/24 depuis namecheap.com/support",
  },
  legalUpdated: "1er juin 2026",
};

export const nav = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const legalLinks = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/conditions-generales-de-vente", label: "CGV" },
  { to: "/conditions-generales-utilisation", label: "CGU" },
  { to: "/politique-de-confidentialite", label: "Politique de confidentialité" },
];
